import { Button, Conditional } from 'iq-blueberry'
import Img from 'components/common/Img'
import ModalOneButton from 'components/common/ModalOneButton'
import Camera from 'components/common/Camera'
import { useTakePhotoButton } from '../hook'
import { LoadingPicture } from './LoadingPicture'

import './style.styl'

export function TakePhotoButtonOptimized({
  showMask = false,
  maskType,
  fileReference,
  side,
  filesReferencesState,
  modifyPayloadKeys,
  reviewImageText,
  handleStepAfterUpload,
  facing = 'user',
  hasUploadError = false,
  readyForNextStep,
  goToNextStep,
  onChange,
  onClick,
}) {
  const {
    shouldOpenCamera,
    setShouldOpenCamera,
    uploadCameraImage,
    handleButtonCameraOption,
    hasCameraAllowed,
    hasCameraAllowedState,
    isLoadingUpload,
    isActivePermissionModal,
    handleClosePermissionModal,
  } = useTakePhotoButton({
    fileReference,
    side,
    filesReferencesState,
    modifyPayloadKeys,
    handleStepAfterUpload,
    hasUploadError,
    onChange,
    readyForNextStep,
    goToNextStep,
  })

  return (
    <div className="take-photo-button-optimized">
      <Button
        className="iq-btn iq-btn--type-primary iq-btn--size-medium iq-btn--expand-x iq-btn--justify-center button-optimized"
        onClick={() => {
          onClick && onClick()
          handleButtonCameraOption()
        }}>
        <div className="button-optimized__text">
          <Img src={`images/camera-white-icon.svg`} /> <span>Tirar foto</span>
        </div>
      </Button>

      <Conditional
        condition={!hasCameraAllowed}
        renderIf={
          <ModalOneButton
            title="Ops, não conseguimos acessar a câmera"
            text="Por favor, você deve autorizar o Consumidor Positivo em parceria com o Banco do Brasil a acessar a câmera do seu dispositivo para continuar."
            buttonText="Tentar novamente"
            hasCloseButton={true}
            isActive={isActivePermissionModal}
            handleButton={handleClosePermissionModal}
          />
        }
      />

      <Conditional
        condition={shouldOpenCamera}
        renderIf={
          <Camera
            optimized
            displayCloseButton={false}
            showMask={showMask}
            maskType={maskType}
            facing={facing}
            outputType="blob"
            reviewImageTitle="A foto está boa?"
            reviewImageText={reviewImageText}
            closeStreamOnTakePicture
            onTakePicture={uploadCameraImage}
            hasCameraAllowedState={hasCameraAllowedState}
            setShouldOpenCamera={setShouldOpenCamera}
          />
        }
      />

      <Conditional
        condition={isLoadingUpload.frontUser && !readyForNextStep}
        renderIf={<LoadingPicture />}
      />
    </div>
  )
}
